import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavigationSectionComponent = _resolveComponent("NavigationSectionComponent")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_FooterSectionComponent = _resolveComponent("FooterSectionComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NavigationSectionComponent),
    _createVNode(_component_router_view, { class: "contentSection" }),
    _createVNode(_component_FooterSectionComponent)
  ]))
}